function formatPhoneNumber(number) {

    return number ? '+' + number.replace(/([^\d])/g, '') : undefined;

}

export default formatPhoneNumber;
